<div aum-dialog-title class="dialog-header">
    <div class="dialog-title">{{ 'aumico_templates_income_selection_popup_title' | i18next }}</div>

    <div class="close-dialog">
        <aum-dialog-actions>
            <mat-icon (click)="closeDialog()" svgIcon="interface-delete 1"></mat-icon>
        </aum-dialog-actions>
    </div>
</div>

<div aum-dialog-content>
    <div class="account-information sticky-accounts-information-header">
        <div class="account-number">
            {{ 'aumico_templates_account_mapping_child_form_number' | i18next }}
        </div>
        <div class="account-name">{{ 'aumico_templates_account_mapping_child_form_name' | i18next }}</div>
    </div>

    <mat-button-toggle-group #group="matButtonToggleGroup" [vertical]="true" (change)="selectedItem($event)">
        <mat-button-toggle *ngFor="let account of incomeAccounts" [value]="account">
            <div class="account-information">
                <div class="account-number">{{ account.accountNumber }}</div>
                <div class="account-name">{{ account.name }}</div>
            </div>
        </mat-button-toggle>
    </mat-button-toggle-group>
</div>

<div aum-dialog-actions>
    <button aum-button (click)="submitSelection()" color="primary" class="dialog-buttons">
        {{ 'aumico_templates_income_selection_popup_done_btn' | i18next }}
    </button>
</div>
